/* ==================================================================
   SHADAZZLE SCENT PICKER
   ==================================================================
   Lets a customer choose which Shadazzle scents come in a bundle.

   The choice is saved as a LINE ITEM PROPERTY on the order, not as a
   variant, so each bundle keeps ONE stock number instead of being
   split across every scent combination. Whoever packs the order sees
   the scents printed on the order line.

   ------------------------------------------------------------------
   FIX 17 Sep 2026 - scents were never reaching the cart.
   The hidden properties[] inputs were appended to the #amarra-scent
   div, which sits OUTSIDE <form action="/cart/add">. A browser only
   submits fields that belong to the form, so every order arrived with
   no scents chosen. data-form was meant to carry the form id, but the
   Custom Liquid block renders it empty and the theme's product form
   has no id, so the two were never linked.
   The script now finds the product form itself, appends the hidden
   inputs INTO it, and re-checks immediately before submit in case the
   section re-renders.

   ------------------------------------------------------------------
   FIX 7 Oct 2026 - picker stopped rendering on the Triple Pack.
   CONFIG is keyed on the product HANDLE. The Triple Pack was renamed
   from shadazzle-cleaner-copy to shadazzle-triple-pack, so the lookup
   missed and init() returned silently - no picker, and every order
   from 4 Oct arrived with no scents (#7922, #7988, #7991).
   Both handles are now listed. IF YOU RENAME ONE OF THESE PRODUCTS,
   ADD THE NEW HANDLE HERE OR THE PICKER WILL DISAPPEAR AGAIN.
   NOTE: the handle is gated TWICE - also in the Custom Liquid block on
   templates/product.shadazzle.json, which decides whether this script
   loads at all. Update BOTH places.
   Same day: the scent pills wrapped onto two lines on mobile. They are
   now equal-width flex items on a single row.
   ================================================================== */
(function () {
  var SCENTS = ['Lemon', 'Lavender', 'Eucalyptus'];
  var ORDINALS = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'];
  var NAMES = ['First Shadazzle', 'Second Shadazzle', 'Third Shadazzle', 'Fourth Shadazzle', 'Fifth Shadazzle', 'Sixth Shadazzle'];

  var CONFIG = {
    'the-spring-clean-amp-organise-set-white': {
      defaults: ['Lemon', 'Eucalyptus'],
      includes: ['1 x Steel Wall Target - White', '1 x Large Utility Basket - White', '3 x Mini Hook Dual Prong - White', '2 x Shadazzle Natural Cleaner - your choice']
    },
    'the-spring-clean-set-white': {
      defaults: ['Lemon', 'Eucalyptus'],
      includes: ['1 x Small Utility Basket - White', '2 x Mini Hook Dual Prong - White', '2 x Shadazzle Natural Cleaner - your choice']
    },
    'shadazzle-triple-pack': {
      defaults: ['Lemon', 'Lavender', 'Eucalyptus'],
      includes: ['3 x Shadazzle Natural Cleaner - your choice of scents']
    },
    'shadazzle-cleaner-copy': {
      defaults: ['Lemon', 'Lavender', 'Eucalyptus'],
      includes: ['3 x Shadazzle Natural Cleaner - your choice of scents']
    },
    'shadazzle-laundry-bundle': {
      defaults: ['Lemon', 'Eucalyptus'],
      includes: ['2 x Shadazzle Natural Cleaner - your choice', '2 x White Gator Magnetics Mini Dual Hooks']
    }
  };

  /* Hidden inputs built for this page, kept so they can be re-attached
     if the section re-renders. */
  var STORES = [];

  /* Find the add-to-cart form: an explicit id from data-form, then the
     form that owns the quantity field, then any cart form with a
     submit button. */
  function findForm(formId) {
    if (formId) {
      var byId = document.getElementById(formId);
      if (byId) return byId;
    }
    var qty = document.querySelector('form[action*="/cart/add"] [name="quantity"]');
    if (qty && qty.closest('form')) return qty.closest('form');

    var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('button[type="submit"], [name="add"]')) return forms[i];
    }
    return forms[0] || null;
  }

  /* Move the hidden inputs into the form so they get submitted.
     Safe to call repeatedly - only acts on inputs not already there. */
  function attach() {
    if (!STORES.length) return;
    var host = document.getElementById('amarra-scent');
    var form = findForm(host ? host.getAttribute('data-form') : null);
    if (!form) return;
    for (var i = 0; i < STORES.length; i++) {
      var el = STORES[i];
      if (el.parentNode !== form) {
        el.removeAttribute('form');
        form.appendChild(el);
      }
    }
  }

  function styles() {
    if (document.getElementById('amarra-scent-css')) return;
    var st = document.createElement('style');
    st.id = 'amarra-scent-css';
    st.textContent = [
      '#amarra-scent{margin:25px 0}',
      '#amarra-scent .amarra-scent__group{margin-bottom:22px}',
      '#amarra-scent .amarra-scent__label{display:block;margin-bottom:10px;font-weight:700}',
      '#amarra-scent .amarra-scent__btns{display:flex;flex-wrap:nowrap;gap:8px}',
      '#amarra-scent .amarra-scent__opt{position:absolute;width:1px;height:1px;opacity:0;pointer-events:none}',
      '#amarra-scent .amarra-scent__pill{flex:1 1 0;min-width:0;text-align:center;white-space:nowrap;display:inline-block;cursor:pointer;padding:11px 10px;border:1px solid #d7d7d7;border-radius:8px;background:#fff;color:#083854;font-weight:600;line-height:1;transition:background .15s ease,border-color .15s ease,color .15s ease}',
      '#amarra-scent .amarra-scent__opt:checked + .amarra-scent__pill{background:#003b5c;border-color:#003b5c;color:#fff}',
      '#amarra-scent .amarra-scent__opt:focus-visible + .amarra-scent__pill{outline:2px solid #f69520;outline-offset:2px}',
      '@media (max-width:430px){#amarra-scent .amarra-scent__btns{gap:6px}#amarra-scent .amarra-scent__pill{padding:11px 4px;font-size:15px}}',
      '#amarra-scent .amarra-scent__sum{margin-top:20px;padding:18px;border-radius:10px;background:#f5f5f5}',
      '#amarra-scent .amarra-scent__sum ul{margin:10px 0 0;padding-left:18px}'
    ].join('');
    document.head.appendChild(st);
  }

  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = 'properties[' + name + ']';
    i.value = value;
    return i;
  }

  function group(idx, checkedScent, store) {
    var wrap = document.createElement('div');
    wrap.className = 'amarra-scent__group';

    var lab = document.createElement('span');
    lab.className = 'amarra-scent__label';
    lab.textContent = 'Choose your ' + (ORDINALS[idx] || 'next') + ' Shadazzle';
    wrap.appendChild(lab);

    var btns = document.createElement('div');
    btns.className = 'amarra-scent__btns';

    SCENTS.forEach(function (scent) {
      var id = 'amarra-scent-' + idx + '-' + scent.toLowerCase();

      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'amarra_scent_' + idx;
      input.id = id;
      input.value = scent;
      input.className = 'amarra-scent__opt';
      if (scent === checkedScent) input.checked = true;
      input.addEventListener('change', function () { store.value = scent; });

      var pill = document.createElement('label');
      pill.className = 'amarra-scent__pill';
      pill.setAttribute('for', id);
      pill.textContent = scent;

      btns.appendChild(input);
      btns.appendChild(pill);
    });

    wrap.appendChild(btns);
    return wrap;
  }

  function summary(items) {
    var box = document.createElement('div');
    box.className = 'amarra-scent__sum';

    var head = document.createElement('strong');
    head.textContent = 'Bundle includes';
    box.appendChild(head);

    var ul = document.createElement('ul');
    items.forEach(function (i) {
      var li = document.createElement('li');
      li.textContent = i;
      ul.appendChild(li);
    });
    box.appendChild(ul);
    return box;
  }

  function init() {
    var host = document.getElementById('amarra-scent');
    if (!host || host.getAttribute('data-built')) return;

    var cfg = CONFIG[host.getAttribute('data-handle')];
    if (!cfg) return;

    host.setAttribute('data-built', '1');
    styles();

    STORES = [];

    cfg.defaults.forEach(function (def, i) {
      var store = hidden(NAMES[i] || ('Shadazzle ' + (i + 1)), def);
      STORES.push(store);
      host.appendChild(group(i, def, store));
    });

    STORES.push(hidden('Bundle Includes', cfg.includes.join(' + ')));
    host.appendChild(summary(cfg.includes));

    attach();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  /* Safety net: re-attach just before the cart form is used, in case
     the theme re-rendered the form after the picker was built. */
  document.addEventListener('submit', attach, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]')) {
      attach();
    }
  }, true);
})();
